/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import Header from './Header';
import Body from './Body';
import TGenericCard from './GenericCard';

/**
 * UI Toolkit Generic Card component based on Veneer Card
 * @public
 */

const GenericCardTemp: any = TGenericCard;
GenericCardTemp.Header = Header;
GenericCardTemp.Body = Body;

const GenericCard = GenericCardTemp;

export default GenericCard;
export type {
  GenericCardContainerProps as GenericCardProps,
  GenericCardHeaderProps,
  GenericCardBodyProps
} from './types';
